import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ObservationCommentService } from '../../observation-comments/services/observation-comment/observation-comment.service';
import { Subscription } from 'rxjs';
import { CommentState } from 'src/app/model/enum/comment-state.enum';
import { EdlComment } from 'src/app/model/comment.model';

@Component({
    selector: 'paetep-publish-all-comments-button',
    templateUrl: './publish-all-comments-button.component.html',
    styleUrls: ['./publish-all-comments-button.component.scss']
})
export class PublishAllCommentsButtonComponent implements OnInit, OnDestroy {
    @Input() modalTitle: string = 'Publish All Comments';

    @Output() onCommentsPublished = new EventEmitter<boolean>();

    public draftCommentCount: number = 0;
    private edlCommentsSubscription?: Subscription;

    constructor(
        private observationCommentService: ObservationCommentService
    ) { }

    ngOnInit(): void {
        this.edlCommentsSubscription = this.observationCommentService.edlCommentsReplaySubject.subscribe((comments) => this.setDraftCounts(comments));
    }

    ngOnDestroy(): void {
        this.edlCommentsSubscription?.unsubscribe();
    }

    public isDisabled() {
        return this.draftCommentCount === 0 || this.observationCommentService.filters.isReadOnly;
    }

    public publishAllCommentsClicked = () => {
        this.observationCommentService
            .publishAllDrafts(this.modalTitle)
            .then((wereCommentsPublished: boolean) => {
                this.onCommentsPublished.emit(wereCommentsPublished);
            });
    }

    private setDraftCounts(comments: EdlComment[] = []) {
        this.draftCommentCount = comments.filter(c => c.commentState === CommentState.DRAFT).length;
    }
}
